import React, {Suspense} from "react";
import ReactDOM from "react-dom/client";
import {Provider} from "react-redux";
import {DataStore} from "@nextlot/core/webcast";
import AuctionsManager from "@nextlot/core/webcast/services/AuctionsManager";
import ViewerEmbeddedRootCmp from "./components/./viewer_embedded/ViewerEmbeddedRootCmp";
import './i18n';
import {NextLotJSDATA_TypeDef} from "@nextlot/core/NextLotJSDATA";
import {WebcastAuctionConnectData_TypeDef} from "@nextlot/core/webcast";


export function load(appConfigData: NextLotJSDATA_TypeDef, webcastAuctionConnectData: WebcastAuctionConnectData_TypeDef) {
    console.log('NLWebcast: --- loading Viewer Embedded screen: ', webcastAuctionConnectData);

    const el_cmp_RootCmp = document.getElementById('cmp_RootCmp');
    if (el_cmp_RootCmp) {

        DataStore.init(appConfigData);

        AuctionsManager.init(DataStore.reduxStore);

        AuctionsManager.createWebcastAuctionHandler(webcastAuctionConnectData);


        ReactDOM.createRoot(el_cmp_RootCmp!)
            .render(
                <Provider store={DataStore.reduxStore}>
                    <Suspense fallback="loading">
                        <ViewerEmbeddedRootCmp/>
                    </Suspense>
                </Provider>
            );

    } else {
        alert('Fatal error: HTML DOM element `#cmp_RootCmp` not found!');
        throw 'HTML DOM element cmp_RootCmp not found.';
    }

}
